import AssetLoader from "@/components/AssetLoader/AssetLoader";
import Userlabel from "@/components/AvatarComponent/Userlabel";
import DebugDataComponent from "@/debug/DebugDataComponent";
import i18n from "@/i18n";
import { AssetTypes } from "@/model/AssetTypes";
import { Contact } from "@/model/db/Contact";
import BFDetailsButton from "@/modules/abstract-ui/general/Button/BFDetailsButton";
import StringUtils from "@/utils/StringUtils";
import classNames from "classnames";
import {
  InvoiceAccount,
  InvoiceAccountBU,
  InvoiceBooking,
} from "../../RAInterfaces";
import "./RABookInvoiceEntry.scss";

interface RABookInvoiceEntryProps {
  booking: InvoiceBooking;
}
const RABookInvoiceEntry = (props: RABookInvoiceEntryProps) => {
  const { booking } = props;
  return (
    <div className={classNames(`ra-book-invoice-entry`)}>
      <DebugDataComponent data={booking} />
      <div className={`__flex padding-bottom-5 __align-center`}>
        <div className={``}>
          <Userlabel id={booking.meta.cf?.id} />
        </div>
        <div className={`__sub-text`}>
          {StringUtils.formatDate(booking.data.creationDate)}
        </div>
      </div>
      <table>
        <tbody>
          <tr>
            <td className="label-column">
              {i18n.t(
                "InvoiceDetails.invoiceAccounting.value",
                "Rechnungsbetrag"
              )}
            </td>
            <td className="value-column">
              {StringUtils.formatCurrency(
                booking.data.value.amount,
                undefined,
                undefined,
                booking.data.value.currency
              )}
            </td>
          </tr>
          <tr>
            <td className="label-column">
              {i18n.t("InvoiceDetails.invoiceAccounting.date", "Buchungsdatum")}
            </td>
            <td className="value-column">
              {StringUtils.formatDate(booking.data.date)}
            </td>
          </tr>
          <tr>
            <td className="label-column">
              {i18n.t(
                "InvoiceDetails.invoiceAccounting.serviceDate",
                "Leistungsdatum"
              )}
            </td>
            <td className="value-column">
              {booking.data.serviceDate
                ? StringUtils.formatDate(booking.data.serviceDate)
                : "-"}
            </td>
          </tr>
          <tr>
            <td className="label-column">
              {i18n.t("InvoiceDetails.invoiceAccounting.account", "Konto")}
            </td>
            <td className="value-column">
              <AssetLoader
                assetType={AssetTypes.Contact}
                id={booking.data.account}
                render={(contact: Contact) => {
                  const accountNumber = contact?.data.contactOverwrite?.find(
                    (e) => e.entity === booking.data.entity
                  )?.[booking.data.kind === "INCOMING" ? "invoice" : "bill"]
                    ?.accountNumber;

                  const label = [accountNumber, contact?.data.displayName]
                    .filter(Boolean)
                    .join(" -");
                  return (
                    <BFDetailsButton
                      appearance="link"
                      noPadding
                      data={{
                        assetId: contact._id,
                        assetType: AssetTypes.Contact,
                      }}
                    >
                      {label}
                    </BFDetailsButton>
                  );
                }}
              />
            </td>
          </tr>

          <tr>
            <td className="label-column">
              {i18n.t(
                "InvoiceDetails.invoiceAccounting.contraAccount",
                "Gegenkonto"
              )}
            </td>
            <td className="value-column">
              <AssetLoader
                inline
                assetType={AssetTypes.Invoicing.Account}
                id={booking.data.contraAccount}
                render={(account: InvoiceAccount) => (
                  <div>
                    {account.data.accountNumber} - {account.data.description}
                  </div>
                )}
              />
            </td>
          </tr>

          <tr>
            <td className="label-column">
              {i18n.t(
                "InvoiceDetails.invoiceAccounting.BU",
                "Buchungsschlüssel"
              )}
            </td>
            <td className="value-column">
              {booking.data.BU ? (
                <AssetLoader
                  inline
                  assetType={AssetTypes.Invoicing.AccountBU}
                  id={booking.data.BU}
                  render={(accountBU: InvoiceAccountBU) => (
                    <div>
                      {accountBU.data.accountNumber} -{" "}
                      {accountBU.data.description}
                    </div>
                  )}
                />
              ) : (
                "-"
              )}
            </td>
          </tr>

          <tr>
            <td className="label-column">
              {i18n.t(
                "InvoiceDetails.invoiceAccounting.referenceField",
                "Belegfeld 1"
              )}
            </td>
            <td className="value-column">
              {booking.data.referenceField || "-"}
            </td>
          </tr>
          <tr>
            <td className="label-column">
              {i18n.t(
                "InvoiceDetails.invoiceAccounting.usageText",
                "Buchungstext"
              )}
            </td>
            <td className="value-column">{booking.data.usage || "-"}</td>
          </tr>
          <tr>
            <td className="label-column">
              {i18n.t("InvoiceDetails.invoiceAccounting.cost1", "KOST 1")}
            </td>
            <td className="value-column">{booking.data.cost1 || "-"}</td>
          </tr>
          <tr>
            <td className="label-column">
              {i18n.t("InvoiceDetails.invoiceAccounting.cost2", "KOST 2")}
            </td>
            <td className="value-column">{booking.data.cost2 || "-"}</td>
          </tr>
          {booking.data.extraInfo?.map((info, index) => (
            <tr>
              <td>
                {i18n.t(
                  "InvoiceDetails.invoiceAccounting.extraInfo",
                  "Zusatzinfo"
                ) +
                  " " +
                  (index + 1)}
              </td>
              <td>{info}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RABookInvoiceEntry;
